import { requestCallNoAccess, requestCall } from "../../api/request";

export const getUserInfo = (accessToken, callback) => {
    const url = "/api/core/account/user-details/";
    requestCall(url, accessToken).then((response) => {
        console.log(response);
        const data = response.data["results"][0];
        callback(false, data);
    }).catch((error) => {
        const data = error.response.data;
        console.log(data);
        callback(data);
    });
};